/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
	name: 'flexProfessionalsView',
	initialState: {
		viewStateByManagementCompany: {}
	},
	reducers: {
		updateViewStateForManagementCompany: (state, action) => {
			const { managementCompanyId, ...partial } = action.payload;
			const existing = state.viewStateByManagementCompany[managementCompanyId] || {};
			state.viewStateByManagementCompany[managementCompanyId] = { ...existing, ...partial };
		}
	}
});

export const { updateViewStateForManagementCompany } = slice.actions;

export const selectViewStateForManagementCompany = (managementCompanyId) => (state) =>
	state.flexProfessionalsView.viewStateByManagementCompany[managementCompanyId];

export default slice.reducer;
